/* Cache-busted v5 interaction layer for the Pre-Glued Lash Kaching deal. */
(function () {
  'use strict';

  var DEAL_ID = '6ec9bcb8-976f-4987-86bb-8645d5a7b7af';
  var OFFER_ONE = '8Fs-';
  var OFFER_TWO = 'XIeg';
  var OFFER_THREE = '1IZ-';
  var DEFAULT_PAIR = ['First Impression (Natural)', 'Signature Look (Soft Glam)'];
  var VARIANTS = {
    '52047573385397': { key: 'natural', label: 'First Impression (Natural)' },
    '52047573418165': { key: 'soft-glam', label: 'Signature Look (Soft Glam)' },
    '52047573450933': { key: 'full-volume', label: 'High Standards (Full Volume)' }
  };
  var artworkLoads = window.__abPregluedKachingArtworkLoads =
    window.__abPregluedKachingArtworkLoads || {};

  function readAssets() {
    var source = document.getElementById('ab-preglued-kaching-assets');
    if (!source) return null;
    try { return JSON.parse(source.textContent); } catch (error) { return null; }
  }

  function cssUrl(value) {
    return value ? 'url("' + String(value).replace(/"/g, '\\"') + '")' : 'none';
  }

  function setStyleProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function variantFromActiveSwatch(layout) {
    var active = layout.querySelector(
      '.tt-product-single-info .tt-options-swatch li.active,' +
      '.tt-product-single-info .tt-options-swatch .active,' +
      '.tt-product-single-info [aria-current="true"]'
    );
    if (!active) return null;
    var text = String(active.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (text.indexOf('soft glam') !== -1) return '52047573418165';
    if (text.indexOf('volume') !== -1) return '52047573450933';
    if (text.indexOf('natural') !== -1) return '52047573385397';
    return null;
  }

  function getMainVariantId(layout) {
    var fromSwatch = variantFromActiveSwatch(layout);
    if (fromSwatch) return fromSwatch;

    var controls = layout.querySelectorAll(
      '.tt-product-single-info select,' +
      '.tt-product-single-info input[name="id"]'
    );
    for (var i = 0; i < controls.length; i++) {
      if (VARIANTS[String(controls[i].value)]) return String(controls[i].value);
    }

    try {
      var fromUrl = new URL(window.location.href).searchParams.get('variant');
      if (VARIANTS[String(fromUrl)]) return String(fromUrl);
    } catch (error) {}

    return '52047573385397';
  }

  function getVariant(layout) {
    return VARIANTS[getMainVariantId(layout)];
  }

  function addDetailCopy(block) {
    var offerTwo = block.querySelector('[data-deal-bar-id="' + OFFER_TWO + '"]');
    var offerThree = block.querySelector('[data-deal-bar-id="' + OFFER_THREE + '"]');

    if (offerTwo) {
      var twoLeft = offerTwo.querySelector('.kaching-bundles__bar-content-left');
      if (twoLeft && !offerTwo.querySelector('.ab-kaching-style-line')) {
        var styleLine = document.createElement('div');
        styleLine.className = 'ab-kaching-style-line';
        styleLine.innerHTML = 'Style: <span></span>';
        twoLeft.appendChild(styleLine);
      }
    }

    if (offerThree) {
      var threeLeft = offerThree.querySelector('.kaching-bundles__bar-content-left');
      if (threeLeft && !offerThree.querySelector('.ab-kaching-mix-match')) {
        var mixMatch = document.createElement('div');
        mixMatch.className = 'ab-kaching-mix-match';
        mixMatch.textContent = 'Mix & Match any style';
        threeLeft.appendChild(mixMatch);
      }
    }
  }

  function preloadArtwork(url, priority) {
    if (!url) return Promise.resolve(false);
    if (artworkLoads[url]) {
      if (
        priority === 'high' &&
        artworkLoads[url].image &&
        'fetchPriority' in artworkLoads[url].image
      ) {
        artworkLoads[url].image.fetchPriority = 'high';
      }
      return artworkLoads[url].promise;
    }

    var image = new Image();
    var record = { image: image, promise: null };
    image.decoding = 'async';
    if ('fetchPriority' in image) image.fetchPriority = priority || 'low';

    record.promise = new Promise(function (resolve) {
      image.onload = function () {
        if (typeof image.decode !== 'function') { resolve(true); return; }
        image.decode().then(function () { resolve(true); }, function () { resolve(true); });
      };
      image.onerror = function () { resolve(false); };
    });

    artworkLoads[url] = record;
    image.src = url;
    return record.promise;
  }

  function primeArtworkAssets(assets, variant) {
    if (!assets || !variant) return;

    var warmAlternates = function () {
      var groups = [assets.kit || {}, assets.applicator || {}];
      for (var i = 0; i < groups.length; i++) {
        for (var key in groups[i]) {
          if (Object.prototype.hasOwnProperty.call(groups[i], key)) {
            preloadArtwork(groups[i][key], 'low');
          }
        }
      }
    };

    var scheduleWarmAlternates = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmAlternates, { timeout: 1800 });
      } else {
        window.setTimeout(warmAlternates, 500);
      }
    };

    if (document.readyState === 'complete') scheduleWarmAlternates();
    else window.addEventListener('load', scheduleWarmAlternates, { once: true });
  }

  function applyArtwork(block, assets, variant, priority) {
    if (!assets || !variant) return;
    priority = priority || 'low';

    var kit = assets.kit && assets.kit[variant.key];
    var applicator = assets.applicator && assets.applicator[variant.key];
    var token = (block.__abKachingArtworkToken || 0) + 1;
    block.__abKachingArtworkToken = token;

    setStyleProperty(block, '--ab-kaching-two-kits-image', cssUrl(assets['two-kits']));
    preloadArtwork(assets['two-kits'], priority);

    Promise.all([
      preloadArtwork(kit, priority),
      preloadArtwork(applicator, priority)
    ]).then(function (loaded) {
      if (block.__abKachingArtworkToken !== token || !loaded[0] || !loaded[1]) return;

      window.requestAnimationFrame(function () {
        if (block.__abKachingArtworkToken !== token) return;
        setStyleProperty(block, '--ab-kaching-kit-image', cssUrl(kit));
        setStyleProperty(block, '--ab-kaching-applicator-image', cssUrl(applicator));
        setAttribute(block, 'data-ab-kaching-style', variant.key);
      });
    });
  }

  function updateStyleCopy(block, variant) {
    var value = block.querySelector('[data-deal-bar-id="' + OFFER_TWO + '"] .ab-kaching-style-line span');
    if (value && value.textContent !== variant.label) value.textContent = variant.label;
  }

  function getVariantControls(block, offerId) {
    var offer = block && block.querySelector('[data-deal-bar-id="' + offerId + '"]');
    if (!offer) return [];

    var controls = offer.querySelectorAll('.kaching-bundles__bar-variant-option');
    if (controls.length) return Array.prototype.slice.call(controls);

    return Array.prototype.slice.call(
      offer.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper')
    );
  }

  function decorateAccessibility(block) {
    var radios = block.querySelectorAll('.kaching-bundles__bar-radio');
    for (var i = 0; i < radios.length; i++) setAttribute(radios[i], 'aria-hidden', 'true');

    var wrappers = getVariantControls(block, OFFER_THREE);
    for (var j = 0; j < wrappers.length; j++) {
      var combo = wrappers[j].querySelector('[role="combobox"]');
      if (combo) setAttribute(combo, 'aria-label', 'Style ' + (j + 1));
    }
  }

  function selectedOfferId(block) {
    var selected = block && block.querySelector('.kaching-bundles__bar--selected');
    return selected && selected.getAttribute('data-deal-bar-id');
  }

  function interactionSnapshot(block) {
    return {
      activeElement: document.activeElement,
      offerId: selectedOfferId(block),
      scrollX: window.scrollX,
      scrollY: window.scrollY
    };
  }

  function isMainVariantTarget(target) {
    var swatch = target && target.closest('.tt-product-single-info .tt-options-swatch');
    if (!swatch) return false;
    var control = target.closest('a, button, label, li');
    var text = String((control && control.textContent) || target.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return text.indexOf('natural') !== -1 ||
      text.indexOf('soft glam') !== -1 ||
      text.indexOf('volume') !== -1;
  }

  function restoreInteraction(block, snapshot) {
    if (!snapshot) return;

    if (snapshot.offerId && selectedOfferId(block) !== snapshot.offerId) {
      var originalOffer = block.querySelector(
        '[data-deal-bar-id="' + snapshot.offerId + '"] .kaching-bundles__bar-main'
      );
      if (originalOffer) originalOffer.click();
    }

    if (snapshot.activeElement && document.documentElement.contains(snapshot.activeElement)) {
      try { snapshot.activeElement.focus({ preventScroll: true }); } catch (error) {}
    }

    if (Math.abs(window.scrollY - snapshot.scrollY) > 1 || Math.abs(window.scrollX - snapshot.scrollX) > 1) {
      window.scrollTo(snapshot.scrollX, snapshot.scrollY);
    }
  }

  function findKachingChoice(wrapper, value) {
    var choices = wrapper ? wrapper.querySelectorAll('[role="option"][data-value]') : [];
    for (var i = 0; i < choices.length; i++) {
      if (choices[i].getAttribute('data-value') === value) return choices[i];
    }
    return null;
  }

  function chooseKachingValueWithoutOpening(wrapper, value) {
    return new Promise(function (resolve) {
      var root = wrapper && wrapper.querySelector('.kaching-bundles-option');
      if (!root || root.getAttribute('data-value') === value) { resolve(true); return; }

      var choice = findKachingChoice(wrapper, value);
      if (choice) {
        invokeKachingClick(choice);
        window.setTimeout(function () { resolve(root.getAttribute('data-value') === value); }, 0);
        return;
      }

      var trigger = root.querySelector('[role="combobox"]');
      if (!trigger || !invokeKachingClick(trigger)) { resolve(false); return; }

      window.setTimeout(function () {
        choice = findKachingChoice(wrapper, value);
        if (!choice) {
          if (trigger.getAttribute('aria-expanded') === 'true') invokeKachingClick(trigger);
          resolve(false);
          return;
        }

        invokeKachingClick(choice);
        window.setTimeout(function () { resolve(root.getAttribute('data-value') === value); }, 0);
      }, 0);
    });
  }

  function invokeKachingClick(element) {
    if (!element) return false;

    if (typeof element.__click === 'function') {
      var event = {
        currentTarget: element,
        defaultPrevented: false,
        preventDefault: function () { this.defaultPrevented = true; },
        stopPropagation: function () {},
        target: element
      };
      element.__click(event);
      return true;
    }

    element.click();
    return true;
  }

  function isLashStyle(value) {
    for (var id in VARIANTS) {
      if (Object.prototype.hasOwnProperty.call(VARIANTS, id) && VARIANTS[id].label === value) return true;
    }
    return false;
  }

  function syncMainOfferVariants(block, variant, state) {
    if (state.syncingMainVariants) {
      state.pendingMainVariant = variant;
      return;
    }

    var wrappers = getVariantControls(block, OFFER_ONE)
      .concat(getVariantControls(block, OFFER_TWO));
    var targets = [];

    for (var i = 0; i < wrappers.length; i++) {
      var root = wrappers[i].querySelector('.kaching-bundles-option');
      if (root && isLashStyle(root.getAttribute('data-value'))) targets.push(wrappers[i]);
    }

    if (!targets.length) return;

    var snapshot = state.mainVariantSnapshot || interactionSnapshot(block);
    state.mainVariantSnapshot = null;
    state.syncingMainVariants = true;
    state.internalSelection = true;

    var sequence = Promise.resolve();
    for (var j = 0; j < targets.length; j++) {
      (function (wrapper) {
        sequence = sequence.then(function () {
          return chooseKachingValueWithoutOpening(wrapper, variant.label);
        });
      }(targets[j]));
    }

    sequence.then(function () {
      restoreInteraction(block, snapshot);
      decorateAccessibility(block);
      state.internalSelection = false;
      state.syncingMainVariants = false;

      if (state.pendingMainVariant) {
        var pending = state.pendingMainVariant;
        state.pendingMainVariant = null;
        syncMainOfferVariants(block, pending, state);
      }
    });
  }

  function readBoxThreeValues(block) {
    var selected = block.querySelectorAll(
      '[data-deal-bar-id="' + OFFER_THREE + '"] .kaching-bundles-option[data-value]'
    );
    if (selected.length !== 2) return null;
    return [selected[0].getAttribute('data-value'), selected[1].getAttribute('data-value')];
  }

  function restoreBoxThreeAfterUserActivation(block, state) {
    if (selectedOfferId(block) !== OFFER_THREE || state.restoringBoxThree) return;

    var wrappers = getVariantControls(block, OFFER_THREE);
    if (wrappers.length !== 2) return;

    var snapshot = interactionSnapshot(block);
    state.restoringBoxThree = true;
    state.internalSelection = true;

    chooseKachingValueWithoutOpening(wrappers[0], state.boxThreeValues[0])
      .then(function () {
        return chooseKachingValueWithoutOpening(wrappers[1], state.boxThreeValues[1]);
      })
      .then(function () {
        restoreInteraction(block, snapshot);
        decorateAccessibility(block);
        state.internalSelection = false;
        state.restoringBoxThree = false;
      });
  }

  function selectDefaultOffer(block, state) {
    if (state.defaultOfferApplied) return;

    var selected = selectedOfferId(block);
    if (selected === OFFER_TWO) {
      state.defaultOfferApplied = true;
      return;
    }

    var main = block.querySelector('[data-deal-bar-id="' + OFFER_TWO + '"] .kaching-bundles__bar-main');
    if (!main) return;

    var snapshot = interactionSnapshot(block);
    state.defaultOfferApplied = true;
    main.click();
    snapshot.offerId = OFFER_TWO;
    restoreInteraction(block, snapshot);
  }

  function initLayout(layout) {
    if (!layout || layout.__abKachingV2Initialised) return;
    layout.__abKachingV2Initialised = true;

    var assets = readAssets();
    primeArtworkAssets(assets, getVariant(layout));
    var state = {
      block: null,
      boxThreeValues: DEFAULT_PAIR.slice(),
      defaultOfferApplied: false,
      internalSelection: false,
      mainVariantSnapshot: null,
      pendingMainVariant: null,
      restoringBoxThree: false,
      scheduled: false,
      shouldSyncMainOffers: false,
      syncingMainVariants: false,
      userVariantIntent: false
    };

    function sync() {
      state.scheduled = false;
      var shouldSyncMainOffers = state.shouldSyncMainOffers;
      var userVariantIntent = state.userVariantIntent;
      state.shouldSyncMainOffers = false;
      state.userVariantIntent = false;

      var block = layout.querySelector('[data-deal-block-id="' + DEAL_ID + '"]');
      if (!block) {
        if (shouldSyncMainOffers) state.shouldSyncMainOffers = true;
        if (userVariantIntent) state.userVariantIntent = true;
        return;
      }

      state.block = block;
      addDetailCopy(block);

      var variant = getVariant(layout);
      applyArtwork(block, assets, variant, userVariantIntent ? 'high' : 'low');
      updateStyleCopy(block, variant);
      decorateAccessibility(block);
      selectDefaultOffer(block, state);

      if (shouldSyncMainOffers) syncMainOfferVariants(block, variant, state);
    }

    function scheduleSync(syncMainOffers) {
      if (syncMainOffers) state.shouldSyncMainOffers = true;
      if (state.scheduled) return;
      state.scheduled = true;
      window.requestAnimationFrame(sync);
    }

    function scheduleMainVariantSync() {
      state.userVariantIntent = true;
      scheduleSync(true);
      window.setTimeout(function () {
        state.userVariantIntent = true;
        scheduleSync(true);
      }, 120);
    }

    function captureMainVariantInteraction(event) {
      if (!state.block || !isMainVariantTarget(event.target)) return;
      state.mainVariantSnapshot = interactionSnapshot(state.block);
      state.mainVariantSnapshot.activeElement = null;
    }

    layout.addEventListener('pointerdown', captureMainVariantInteraction, true);
    layout.addEventListener('click', function (event) {
      if (!state.mainVariantSnapshot) captureMainVariantInteraction(event);
    }, true);

    layout.addEventListener('change', function (event) {
      if (!event.target.closest('.tt-product-single-info')) return;
      scheduleMainVariantSync();
    });

    layout.addEventListener('click', function (event) {
      if (!isMainVariantTarget(event.target)) return;
      scheduleMainVariantSync();
    });

    layout.addEventListener('click', function (event) {
      if (state.internalSelection || !state.block) return;

      var boxThreeMain = event.target.closest(
        '[data-deal-bar-id="' + OFFER_THREE + '"] .kaching-bundles__bar-main'
      );
      if (boxThreeMain) {
        window.setTimeout(function () {
          restoreBoxThreeAfterUserActivation(state.block, state);
        }, 80);
        return;
      }

      var option = event.target.closest(
        '[data-deal-bar-id="' + OFFER_THREE + '"] [role="option"][data-value]'
      );
      if (!option) return;

      window.setTimeout(function () {
        var values = readBoxThreeValues(state.block);
        if (values) state.boxThreeValues = values;
      }, 0);
    }, true);

    var observer = new MutationObserver(function (mutations) {
      var selector = '[data-deal-block-id="' + DEAL_ID + '"]';

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (
          state.block &&
          (mutation.target === state.block || state.block.contains(mutation.target))
        ) {
          scheduleSync(false);
          return;
        }

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (
            node.nodeType === 1 &&
            (node.matches(selector) || node.querySelector(selector))
          ) {
            scheduleSync(false);
            return;
          }
        }
      }
    });
    observer.observe(layout, { childList: true, subtree: true });

    scheduleSync(true);
  }

  function boot() {
    var layouts = document.querySelectorAll('.pregluedlashextensions-layout');
    for (var i = 0; i < layouts.length; i++) initLayout(layouts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());
